// extracted by mini-css-extract-plugin
export default {"containerWelcome":"styles_containerWelcome__9Cg4E","welcome":"styles_welcome__8InQz"};